export default {
  workspace: "Member Workspace",
  selectedGroup: "Selected Group",
  userFallback: "User",
  welcome: "Welcome, {name}",
  roleLabel: "Role",
  secureOtp: "Secure OTP Login",

  actions: {
    openMenu: "Open menu",
    closeMenu: "Close menu",
    logout: "Logout",
  },

  roles: {
    owner: "Owner",
    admin: "Administrator",
    treasurer: "Treasurer",
    member: "Member",
  },

  admin: {
    section: "Admin",
    panel: "Admin Panel",
  },

  menu: {
    sections: {
      overview: "Overview",
      savings: "Savings",
      loans: "Loans",
      account: "Account",
    },

    items: {
      dashboard: "Dashboard",
      statement: "Statement",
      contributions: "Contributions",
      loans: "Loans",
      penalties: "Penalties",
      loan_applications: "Loan Applications",
      withdrawals: "Withdrawals",
      profile: "Profile",
    },
  },
};
